import React, {useCallback, useState} from 'react';
import {Button, Typography} from 'lark';
import {QR_STATE, ValueOfQRCodeState} from '~/service/qrCode';
import './index.less';

const {Text} = Typography;

interface Props {
    qrId: string;
    qrState: ValueOfQRCodeState;
    handleClick: () => void;
}

const QRCodeWrapper = (props: Props) => {
    const {qrId = '', qrState, handleClick} = props;
    const getQrUrl = useCallback(
        () => `${window.location.origin}/cas/dispatcher/qrcode/qrImg?k=${qrId}`,
        [qrId]
    );

    // 二维码是否失效
    const isInvalid = qrState === QR_STATE.EXPIRED
            || qrState === QR_STATE.INEXISTENT
            || qrState === QR_STATE.UNKNOWN;

    return (
        <div className="qr-code-wrapper">
            {isInvalid && (
                <div className="qr-code-invalid">
                    <Text className="invalid-text">二维码已失效</Text>
                    <Button className="refresh-btn" onClick={handleClick}>刷新</Button>
                </div>
            )}
            {qrId && <img className="qr-code" src={getQrUrl()} alt="二维码" />}
        </div>
    );
};

export default QRCodeWrapper;
